module.exports = __webpack_public_path__ + "img/logomini.42ebc8d7.png";